export default __webpack_public_path__ + "static/media/headshot1.d3aeab3c.jpg";